package org.hs_soft.runmynesto.di.home

import org.hs_soft.runmynesto.data.api_datasource.authentication.FetchIdTokenRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.authentication.SignOutRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.home.DeleteCacheRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.home.GetLanguageRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.home.GlobalSearchRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.home.HSSoftAppsRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.home.ShopListRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.home.UserProfileDataRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.options.virtual_card.GetVirtualCardInfoRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_product_general.GetDataAssistantAnswerRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_product_general.GetDataAssistantMessageHistoryRepositoryImpl
import org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_product_general.SaveDataAssistantFavoriteMessagesRepositoryImpl
import org.hs_soft.runmynesto.data.local_datasource.local_storage.home.GetSavedCheckOutRepositoryImpl
import org.hs_soft.runmynesto.data.local_datasource.local_storage.home.GetShopListRepositoryImpl
import org.hs_soft.runmynesto.data.local_datasource.local_storage.home.SaveCheckOutRepositoryImpl
import org.hs_soft.runmynesto.data.local_datasource.local_storage.home.SetIsNewCustomerRepositoryImpl
import org.hs_soft.runmynesto.domain.repository.local_datasource.home.GetLanguageRepository
import org.hs_soft.runmynesto.domain.repository.local_datasource.home.GetSavedCheckOutRepository
import org.hs_soft.runmynesto.domain.repository.local_datasource.home.GetSavedShopllistRepository
import org.hs_soft.runmynesto.domain.repository.local_datasource.home.SaveCheckOutRepository
import org.hs_soft.runmynesto.domain.repository.local_datasource.home.SetNewCustomerRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.DeleteCacheRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.FetchIdTokenRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.GlobalSearchRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.HSSoftAppsRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.SignOutRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.UserProfileDataRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.media_center.tabs.media.ShopListRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.virtual_card.GetVirtualCardInfoRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_product_general.GetDataAssistantAnswerRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_product_general.GetDataAssistantMessageHistoryRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_product_general.SaveDataAssistantFavoriteMessagesRepository
import org.koin.dsl.module

val homeRepositoryModule= module {

    single<GlobalSearchRepository> {
        GlobalSearchRepositoryImpl(get(),get())
    }
    single<SetNewCustomerRepository>{
        SetIsNewCustomerRepositoryImpl()
    }
    single<FetchIdTokenRepository> {
        FetchIdTokenRepositoryImpl()
    }
    single<GetSavedCheckOutRepository> {
        GetSavedCheckOutRepositoryImpl()
    }

    single<SaveCheckOutRepository> {
        SaveCheckOutRepositoryImpl()
    }

    single<SignOutRepository>{
        SignOutRepositoryImpl()
    }
    single<UserProfileDataRepository> {
        UserProfileDataRepositoryImpl(get(),get())
    }

    single<HSSoftAppsRepository>{
        HSSoftAppsRepositoryImpl(get(),get())
    }
    single<ShopListRepository>{
        ShopListRepositoryImpl(
            apiClient = get(),
            requestManager = get(),
        )
    }
    single<GetSavedShopllistRepository>{
        GetShopListRepositoryImpl()
    }

    single<DeleteCacheRepository>{
        DeleteCacheRepositoryImpl()
    }

    single<GetLanguageRepository> {
        GetLanguageRepositoryImpl()
    }


    single<GetDataAssistantAnswerRepository>{
        GetDataAssistantAnswerRepositoryImpl(get())
    }

    single<GetDataAssistantMessageHistoryRepository>{
        GetDataAssistantMessageHistoryRepositoryImpl(get())
    }

    single<SaveDataAssistantFavoriteMessagesRepository>{
        SaveDataAssistantFavoriteMessagesRepositoryImpl(get())
    }


    single<GetVirtualCardInfoRepository>{
        GetVirtualCardInfoRepositoryImpl(
            apiClient = get(),
            requestManager = get()
        )
    }

}